import React, { useEffect, useState } from 'react';
import { Form, Input, InputNumber, Button, message, Select, Card, Divider, DatePicker, ConfigProvider, Radio, Popconfirm } from 'antd';
import axios from 'axios';
import API_BASE_URL from '../../config/api';
import { SaveOutlined, CopyOutlined } from '@ant-design/icons';
import th_TH from 'antd/es/locale/th_TH';
import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import 'dayjs/locale/th';

dayjs.extend(buddhistEra);
dayjs.locale('th');

const { TextArea } = Input;

// ฟังก์ชัน format ที่แปลงเป็น พ.ศ.
const formatBuddhistDate = (date) => {
    return date ? `${date.date()}/${date.month() + 1}/${date.year() + 543}` : '';
};


const TempleStatisticsForm = ({ templeId, year, isEdit = false, setIsEdit, printPDF, setYear }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [isFormEdit, setIsFormEdit] = useState(isEdit)
    const [formYear, setFormYear] = useState(2025);
    const [copyLoading, setCopyLoading] = useState(false);

    const API_BASE = `${API_BASE_URL}/api/temple-statistics`; //    ดึงสถิติประจำปี

    useEffect(() => {
        setFormYear(year);
    }, []);


    useEffect(() => {

        setLoading(true);

        if (isEdit && templeId && formYear) {
            axios.get(`${API_BASE}/${templeId}/${formYear}`)
                .then(res => {
                    //console.log('isRes:', res.data);
                    // แปลง string → dayjs ก่อน set ลง Form
                    form.setFieldsValue({ ...res.data, sendAt: dayjs(res.data.sendAt, 'YYYY-MM-DD') });
                    // message.success('โหลดข้อมูลสถิติสำเร็จ');
                    // setFormYear(year);
                    setIsFormEdit(true);
                    setLoading(false);
                })
                .catch(() => {
                    message.error('ไม่สามารถโหลดข้อมูลเก่าได้ หรืออาจยังไม่มีข้อมูลสถิติของปีที่เลือก');
                    setIsFormEdit(false);
                    setLoading(false);
                });

        }
    }, [templeId, formYear, isEdit]);

    const onFinish = async (values) => {

        const dateObj = values.sendAt;

        // แปลงวันเป็น YYYY-MM-DD สำหรับบันทึก MySQL
        const sendAt = dateObj?.format('YYYY-MM-DD');
        // console.log('ส่งไป MySQL:', sendAt);
        const payload = {
            ...values,
            sendAt: sendAt ? sendAt : '2025-06-19',
            temple_id: templeId,
            year: formYear
        };

        console.log(payload, payload);

        const token = localStorage.getItem('token');

        setLoading(true);

        try {
            if (isFormEdit) {
                await axios.put(`${API_BASE}/${templeId}/${formYear}`, payload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                message.success('แก้ไขข้อมูลเรียบร้อยแล้ว');
                setIsFormEdit(true);
            } else {
                await axios.post(`${API_BASE}`, payload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                message.success('บันทึกข้อมูลสำเร็จ');
                setIsFormEdit(true);
            }


        } catch (err) {
            //message.error('เกิดข้อผิดพลาดในการส่งข้อมูล');
        } finally {
            setLoading(false);
        }
    };

    const handleChangeYear = e => {

        if (year === e.target.value) {
            setFormYear(e.target.value);
            setYear(e.target.value);
            setIsFormEdit(true)
        } else {
            setFormYear(e.target.value);
            setYear(e.target.value);
            setIsFormEdit(false)
        }
    };

    const handleCopyFromPrevYear = async () => {
        const prevYear = Number(formYear) - 1;
        if (prevYear < 2023) {
            message.warning('ไม่มีข้อมูลปีก่อนหน้าให้คัดลอก');
            return;
        }
        setCopyLoading(true);
        try {
            const res = await axios.get(`${API_BASE}/${templeId}/${prevYear}`);
            const { id, temple_id, year: _, sendAt, ...rest } = res.data;
            // เคลียร์ฟิลด์ที่ไม่ควรคัดลอก แล้วใส่ข้อมูลที่เหลือลงฟอร์ม
            form.setFieldsValue({
                ...rest,
                sendAt: sendAt ? dayjs(sendAt, 'YYYY-MM-DD') : null,
            });
            message.success(`คัดลอกข้อมูลจากปี ${prevYear + 543} เรียบร้อยแล้ว กรุณาตรวจสอบและบันทึก`);
        } catch (err) {
            message.error(`ไม่พบข้อมูลสถิติของปี ${prevYear + 543} กรุณาตรวจสอบว่ามีการบันทึกปีนั้นไว้แล้ว`);
        } finally {
            setCopyLoading(false);
        }
    };

    return (
        <ConfigProvider locale={th_TH}>
            <Card
                title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>ฟอร์มกรอกข้อมูลวัด</span>
                        <Button type="primary"
                            htmlType="submit"
                            onClick={() => form.submit()}
                            icon={<SaveOutlined />}
                            size='large'
                        >
                            {isEdit ? 'บันทึกการแก้ไข' : 'บันทึกข้อมูล'}
                        </Button>
                    </div>
                }
                actions={[
                    <Button type="primary"
                        htmlType="submit"
                        onClick={() => form.submit()}
                        icon={<SaveOutlined />}
                        size='large'
                    >
                        {isEdit ? 'บันทึกการแก้ไข' : 'บันทึกข้อมูล'}
                    </Button>,
                    <Button type="primary" onClick={printPDF} style={{ marginBottom: 16, width: 250 }} size="large">
                        พิมพ์ข้อมูลวัด
                    </Button>
                ]}

            >

                {/* ปุ่มคัดลอกจากปีที่แล้ว */}
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
                    <Popconfirm
                        title={`คัดลอกข้อมูลจากปี ${Number(formYear) + 542} มาสู่ปี ${Number(formYear) + 543}?`}
                        description="ข้อมูลในฟอร์มปัจจุบันจะถูกแทนที่ด้วยข้อมูลปีก่อนหน้า"
                        onConfirm={handleCopyFromPrevYear}
                        okText="ยืนยัน"
                        cancelText="ยกเลิก"
                    >
                        <Button
                            icon={<CopyOutlined />}
                            loading={copyLoading}
                            size="large"
                        >
                            คัดลอกจากปีที่แล้ว
                        </Button>
                    </Popconfirm>
                </div>

                <Divider orientation="center">กรุณาเลือกปีที่จะบันทึกข้อมูล  </Divider>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center', // จัดกลางแนวนอน
                        alignItems: 'center', // จัดกลางแนวตั้ง
                    }}
                >
                    <Radio.Group name="year" value={formYear} onChange={handleChangeYear} >
                        {Array.from(
                            { length: new Date().getFullYear() - 2023 + 1 },
                            (_, i) => 2023 + i
                        ).map(adYear => (
                            <Radio.Button key={adYear} value={String(adYear)}>
                                {adYear + 543}
                            </Radio.Button>
                        ))}
                    </Radio.Group>
                </div>

                <Form
                    form={form}
                    layout="horizontal"
                    onFinish={onFinish}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 14 }}
                    labelWrap={true}
                >

                    <Divider orientation="left">๑.ผู้นำส่งข้อมูล  </Divider>
                    <Form.Item name="sender_name" label="พระผู้นำส่งข้อมูล">
                        <Input />
                    </Form.Item>
                    <Form.Item name="sendAt" label="เลือกวันที่นำส่งข้อมูล">
                        <DatePicker
                            style={{ width: '100%' }}
                            format={formatBuddhistDate}
                            placeholder="เลือกวันที่"
                            getPopupContainer={(trigger) => trigger.parentNode}
                        />
                    </Form.Item>
                    <Divider orientation="left">  ๒.นามวัด(ใช้ข้อมูลจากข้อมูลพื้นฐานวัด)</Divider>
                    <Divider orientation="left">    ๓.นามเจ้าอาวาส(ใช้ข้อมูลจากข้อมูลพื้นฐานวัด)</Divider>
                    <Divider orientation="left">  ๔.จำนวนพระภิกษุสามเณร-ศิษย์วัด</Divider>
                    <Form.Item name="monks_count" label="จำนวนภิกษุ">
                        <InputNumber min={0} />
                    </Form.Item>
                    <Form.Item name="novices_count" label="จำนวนสามเณร">
                        <InputNumber min={0} />
                    </Form.Item>
                    <Form.Item name="temple_students_count" label="จำนวนลูกศิษย์วัด">
                        <InputNumber min={0} />
                    </Form.Item>
                    <Divider orientation="left">๕.จำนวนพระภิกษุสามเณรเปรียญ</Divider>
                    <Form.Item name="pariyatti_count" label="จำนวนภิกษุ-สามเณรเปรียญ">
                        <InputNumber min={0} />
                    </Form.Item>
                    <Form.Item name="pariyatti_detail" label="รายละเอียดภิกษุ-สามเณรเปรียญ แต่ละประโยค">
                        <TextArea rows={2} />
                    </Form.Item>
                    <Divider orientation="left">๖.จำนวนภิกษุ-สามเณรนักธรรม</Divider>
                    <Form.Item name="monks_naktham3_count" label="พระภิกษุนักธรรมเอก">
                        <InputNumber min={0} />
                    </Form.Item>
                    <Form.Item name="novices_naktham3_count" label="สามเณรนักธรรมเอก">
                        <InputNumber min={0} />
                    </Form.Item>
                    <Divider orientation="left">๗.จำนวนภิกษุปาฏิโมกข์</Divider>
                    <Form.Item name="monks_patimokkha_count" label="พระภิกษุปาฏิโมกข์/รูป">
                        <InputNumber min={0} />
                    </Form.Item>
                    <Form.Item name="monks_over10_pansa_count" label="พระมีพรรษาพ้นสิบ (มากกว่า 10 พรรษา)/รูป">
                        <InputNumber min={0} />
                    </Form.Item>
                    <Divider orientation="left">๘.พระภิกษุทรงสมณศักดิ์</Divider>
                    <Form.Item name="monks_with_titles_count" label="จำนวนภิกษุที่มีสมณศักดิ์">
                        <InputNumber min={0} />
                    </Form.Item>
                    <Form.Item name="monk_titles_detail" label="ภิกษุที่มีสมณศักดิ์ คือ">
                        <TextArea rows={2} />
                    </Form.Item>

                    <Divider orientation="left">๙.ที่ดินตั้งวัด และที่ธรณีสงฆ์</Divider>
                    <Form.Item name="land_temple_rai" label="ที่ดินตั้งวัด (ไร่)">
                        <Input />
                    </Form.Item>

                    <Form.Item name="land_dharma_rai" label="ที่ธรณีสงฆ์ (ไร่)">
                        <Input />
                    </Form.Item>

                    <Divider orientation="left">๑๐.ปีที่ตั้งวัด และเจ้าอาวาส</Divider>

                    <Form.Item name="total_former_abbots" label="มีเจ้าอาวาสมาแล้ว (รูป)">
                        <InputNumber min={0} />
                    </Form.Item>

                    <Divider orientation="left">๑๑.การจัดกิจกรรมภายในวัด และการมีส่วนร่วมกับชุมชน</Divider>
                    <Form.Item name="preach_on_buddha_days" label="การแสดงธรรมวันพระ">
                        <Select>
                            <Select.Option value="มีทุกวันธรรมสวนะ">มีทุกวันธรรมสวนะ</Select.Option>
                            <Select.Option value="-">-</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item name="listeners_in_rainy" label="มีอุบาสกอุบาสิกามาฟังธรรมวันหนึ่งอย่างมากในพรรษา(คน)">
                        <InputNumber min={0} />
                    </Form.Item>

                    <Form.Item name="listeners_out_rainy" label="มีอุบาสกอุบาสิกามาฟังธรรมวันหนึ่งอย่างมากนอกพรรษา (คน)">
                        <InputNumber min={0} />
                    </Form.Item>
                    <Divider orientation="left">๑๒.ศาสนสมบัติ และศาสนสถานของวัด</Divider>
                    <Form.Item name="religious_assets" label="ศาสนสมบัติของวัดที่สำคัญ เช่น ศาสนวัตถุ คือ">
                        <TextArea rows={3} />
                    </Form.Item>

                    <Form.Item name="religious_structures" label="ศาสนสถาน คือ">
                        <TextArea rows={3} />
                    </Form.Item>
                    <Divider orientation="left">๑๓.การจัดการศึกษา</Divider>
                    <Form.Item name="has_priyatti_school" label="มีโรงเรียนปริยัติธรรม">
                        <Select>
                            <Select.Option value="มีการเรียนการสอนปริยัติธรรมแผนกธรรม/บาลี">มีการเรียนการสอนปริยัติธรรมแผนกธรรม/บาลี</Select.Option>
                            <Select.Option value="มีการเรียนการสอนปริยัติธรรมแผนกธรรม">มีการเรียนการสอนปริยัติธรรมแผนกธรรม</Select.Option>
                            <Select.Option value="มีการเรียนการสอนปริยัติธรรมแผนกบาลี">มีการเรียนการสอนปริยัติธรรมแผนกบาลี</Select.Option>
                            <Select.Option value="ไม่มี">ไม่มี</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item name="priyatti_students_count" label="จำนวนนักเรียนโรงเรียนปริยัติธรรม">
                        <InputNumber min={0} />
                    </Form.Item>
                    <Divider orientation="left">๑๔.การเผยแผ่</Divider>
                    <Form.Item name="meditation_training" label="มีการอบรมกรรมฐาน">
                        <TextArea rows={2} />
                    </Form.Item>
                    <Divider orientation="left">๑๕.การสาธารณสงเคราะห์</Divider>
                    <Form.Item name="public_benefit_activity" label="การบำเพ็ญสาธารณสงเคราะห์">
                        <TextArea rows={3} />
                    </Form.Item>
                    <Divider orientation="left">๑๖.การศึกษาสงเคราะห์</Divider>
                    <Form.Item name="has_school_for_children" label="มีโรงเรียนสำหรับฆราวาสในวัด">
                        <TextArea rows={2} />
                    </Form.Item>
                    <Divider orientation="left">ภาพรวม</Divider>
                    <Form.Item
                        name="summary_monks_change"
                        label={`เป็นพระอารามหลวงชั้นตรี,โท, เอก หรือวัดราษฎร์ จำนวนพระภิกษุ-สามเณรและศิษย์วัดเพิ่มขึ้น หรือลดลง เป็นต้น`}>
                        <TextArea rows={2} />
                    </Form.Item>
                </Form>
            </Card>
        </ConfigProvider>
    );
};

export default TempleStatisticsForm;
